import DocumentServices from "../../services/documents.services";
import {
  documemtSectionHeaders,
  documentStates,
  documentType,
  getDocumentRows,
} from "./constants";
import styles from "./Documents.module.scss";
import clsx from "clsx";
import menuButton from "../../assets/images/documentEllipse.svg";
import { Popover } from "antd";
import { PlacementPositions } from "../../enums/PlacementPositionsEnums";
import EditMenuItem from "./EditMenuItems";
import { useState } from "react";
import { PopoverTrigger } from "../../enums/PopoverEnums";
const Documents = () => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const { quoteSectionHeader, estimateSectionHeader } = documemtSectionHeaders;
  const { primary } = documentStates;
  const { FetchDocumentDetails } = DocumentServices();
  const { data, refetch: refetchDetails } = FetchDocumentDetails({});
  const estimateRows = getDocumentRows(data, documentType.estimate);
  const quoteRows = getDocumentRows(data, documentType.quote);
  return (
    <>
      <div className={styles.documentContainer}>
        <div className={styles.quoteSectionContainer}>
          <div className={styles.quoteSectionHeader}>{quoteSectionHeader}</div>
          {quoteRows?.map?.((content, index) => (
            <div
              className={clsx({
                [styles.individualRows]: index !== quoteRows?.length - 1,
                [styles.borderNone]: index === quoteRows?.length - 1,
              })}
            >
              <div className={styles.rowContent}>
                <div className={styles.rowContentDetails}>
                  <div className={styles.rowContentName}>{content?.name}</div>
                  <div className={styles.rowContentStatus}>
                    {content?.isPrimary ? primary : ""}
                  </div>
                </div>
                <div className={styles.rowContentDate}>{content?.date}</div>
              </div>
              <div className={styles.rowEllipse}>
                <Popover
                  trigger={PopoverTrigger.HOVER}
                  content={
                    <EditMenuItem
                      id={content?.id}
                      isPrimary={content?.isPrimary}
                      docType={documentType.quote}
                      name={content?.name}
                      refetchDetails={refetchDetails}
                    />
                  }
                  overlayClassName={styles.PopoverContainer}
                  placement={PlacementPositions.BOTTOM_RIGHT}
                >
                  <span>
                    <img src={menuButton} />
                  </span>
                </Popover>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.estimateSectionContainer}>
          <div className={styles.estimateSectionHeader}>
            {estimateSectionHeader}
          </div>
          {estimateRows?.map?.((content, index) => (
            <div
              className={clsx({
                [styles.individualRows]: index !== estimateRows?.length - 1,
                [styles.borderNone]: index === estimateRows?.length - 1,
              })}
            >
              <div className={styles.rowContent}>
                <div className={styles.rowContentDetails}>
                  <div className={styles.rowContentName}>{content?.name}</div>
                  <div className={styles.rowContentStatus}>
                    {content?.isPrimary ? primary : ""}
                  </div>
                </div>
                <div className={styles.rowContentDate}>{content?.date}</div>
              </div>
              <div className={styles.rowEllipse}>
                <Popover
                  content={
                    <EditMenuItem
                      id={content?.id}
                      isPrimary={content?.isPrimary}
                      docType={documentType.estimate}
                      name={content?.name}
                      refetchDetails={refetchDetails}
                    />
                  }
                  trigger={PopoverTrigger.HOVER}
                  overlayClassName={styles.PopoverContainer}
                  placement={PlacementPositions.BOTTOM_RIGHT}
                >
                  <img src={menuButton} />
                </Popover>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Documents;
